/**
 * @flow
 * Created by neo on 02.06.17.
 */

import React, {Component} from 'react';
import {observer} from 'mobx-react';
import { translate  } from 'react-i18next';
import { Button, Row, Col, Card, FormGroup, Label, Input, Alert, CardBody } from 'reactstrap';
import Booking from '../../Store/Booking';
import Passenger from '../../Store/Booking/Passenger';
import ShortAlert from './ShortAlert';
import DisplayToggle from '../../Components/DisplayToggle'
import Settings from '../../Store/Settings'

type Props = {
  booking: Booking
};

@observer
export class PassengerInfo extends Component {

  state: {
    collapse: boolean,
    passenger: boolean,
    updating: boolean
  };

  constructor(props: Props) {
    super(props);
    this.state = {
      collapse: false,
      passenger: true,
      updating: false
    };
  }

  toggleCollapse = () => {
    this.setState({ collapse: !this.state.collapse });
  };

  handleUpdate = async () => {
    this.setState({ updating: true });
    const res = await this.props.booking.updatePassengers();
    this.setState({ updating: false, showAlert: true });
  };

  handleHideAlert = () => {

  };
  
  getInsuranceLink = () => {
    const data = Settings.settings.get('tos_url');
    if(data) {
      return data;
    } else {
      const file = Settings.settings.get('tos_file');
      if (file) {
        return file.url;
      }
    }
  };
  
  getSafteyLink = () => {
    const data = Settings.settings.get('safety_url');
    if(data) {
      return data;
    } else {
      const file = Settings.settings.get('safety_file');
      if (file) {
        return file.url;
      }
    }
  };

  render() {

    const { booking, t } = this.props;
    const insuranceLink = this.getInsuranceLink();
    const safteyLink = this.getSafteyLink();
    const { settings } = Settings;

    return (
      <Card>
        <div className="card-header">
          {t('Passagiere')}
        </div>
        {
          this.state.showAlert ?
            (<CardBody>
              <ShortAlert
                color="success"
                isOpen={this.state.showAlert}
                onHide={this.handleHideAlert}
              >
                {t('Ihre Passagierliste wurde erfolgreich aktualisiert')}
              </ShortAlert>
            </CardBody>)
          : null
        }
        <CardBody>
          <Row>
            <Col>
              {booking.passengers.map((p: Passenger, i: number) => {
                return (
                  <Row key={i}>
                    <Col xs="12" lg="4">
                      <div className="d-lg-none">{t('Passenger')} {i+1}</div>
                      <FormGroup>
                        <Input
                          type="text"
                          placeholder={t('Name')}
                          value={p.last_name}
                          disabled={!booking.canChangePassengers}
                          onChange={(e) => p.last_name = e.target.value}
                        />
                      </FormGroup>
                    </Col>
                    <Col xs="12" lg="4">
                      <FormGroup>
                        <Input
                          type="text"
                          placeholder={t('Vorname')}
                          value={p.first_name}
                          disabled={!booking.canChangePassengers}
                          onChange={(e) => p.first_name = e.target.value}
                        />
                      </FormGroup>
                    </Col>
                    <Col xs="12" lg="4">
                      <FormGroup>
                        <Input
                          type="number"
                          placeholder={t('Gewicht ({{unit}})', { unit: t(`unit.${settings.get('weight_unit')}`) })}
                          value={p.weight}
                          disabled={!booking.canChangePassengers}
                          onChange={(e) => p.weight = Number(e.target.value)}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                );
              })}
            </Col>
          </Row>
        </CardBody>
        {booking.canChangePassengers ?
          <CardBody>
            <Row>
              <Col>
                <p>{t('Hiermit bestätige ich, dass alle Passagiere bis zum Abflug')}</p>
              </Col>
            </Row>
            <Row>
              <Col>
                <FormGroup>
                  <Label check>
                    <Input type="checkbox" checked={this.props.booking.check_insurance_info} onClick={(e) => this.props.booking.check_insurance_info = e.target.checked}/>{' '}
                    {t('über die Versicherungsbestimmungen bis zum Abflug orientiert wurden,')}
                    <br />
                    <DisplayToggle show={insuranceLink}>
                      <a href={insuranceLink} target="_blank">{t('Zu den Versicherungsbestimmungen')}</a>
                    </DisplayToggle>
                  </Label>
                </FormGroup>
                <FormGroup>
                  <Label check>
                    <Input type="checkbox" checked={this.props.booking.check_safety_info} onClick={(e) => this.props.booking.check_safety_info = e.target.checked}/>{' '}
                    {t('das Saftey-Video gesehen haben.')}{'*'}
                    <br />
                    <DisplayToggle show={safteyLink}>
                      <a href={safteyLink} target="_blank">{t('Zum Saftey-Video')}</a>
                    </DisplayToggle>
                  </Label>
                </FormGroup>
              </Col>
            </Row>
          </CardBody>
          : null
        }
        {
          booking.canChangePassengers ?
            <CardBody>
              {
                (!booking.check_insurance_info || !booking.check_safety_info) &&
                <Alert color="danger">
                  {'*'} {t('You must agree to the terms and conditions')}
                </Alert>
              }
              <Button color="primary" onClick={this.handleUpdate} disabled={this.state.updating || !booking.check_insurance_info || !booking.check_safety_info}>{t('Passagierliste aktualisieren')}</Button>
            </CardBody>
          : null
        }
        {
          booking.canChangePassengers ?
            <CardBody>
              <Alert color="info">
                {t('Sie können bis 24 Stunden vor Abflug diese Passagierliste bearbeiten. Sie erhalten den Zugriff per E-Mail')}
              </Alert>
              <Alert color="warning">
                {t('Anders als bei Linienflugzeugen, ist die Angabe des Gewichtes eines Passagier für Helikopterflüge sehr wichtig für Ihre Sicherheit.')}
              </Alert>
            </CardBody>
          : null
        }
        {
          !booking.canChangePassengers ?
            <CardBody>
              <Alert color="warning">
                {t('Sie können die Passagierliste nicht mehr bearbeiten. Der Flug findet bald statt oder hat bereits stattgefunden.')}
              </Alert>
            </CardBody>
          : null
        }
      </Card>
    );
  }
}

export default translate ()(PassengerInfo);



// WEBPACK FOOTER //
// ./src/App/Booking/View/PassengerInfo.js